export const dark = {
    name: "dark-theme",
    colors: {
        bg: "#f0f2f5",
        bgGradient: `linear-gradient(135deg, #e0eaf2 0%, #f0e8f0 50%, #e0eaf2 100%)`,
        headline: "#1e3d58",
        paragraph: "grey",
        cardBG: "#ffffff",
        cardText: "#000000",
        ff: "'Inter', sans-serif",
        ffHeading: "'DM Serif Display', serif",
        activeColor: "#007BFF",
        activeColorDarkened: "#0570e3",
        lightActiveHover: "#E6F0FF",
        contrastText: "#000000",
        borderColor: "#DDDDDD",
        opacityColor: "#f7f7f7",
        subTextColor: "#717171",
        inputBg: "#ffffff",
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.15)",
        themeToggleTranslate: 'translateX(0px)',
        themeToggleContrast: 'grey',
        themeActiveDisabled: '#e0e0e0',
        successColor: '#10b981',
        errorColor: '#ef4444',
        warningColor: '#f59e0b'
    },
    radii: { sm: '8px', md: '12px', lg: '20px', pill: '50px' },
    shadows: {
        sm: '0 2px 8px rgba(0, 0, 0, 0.06)',
        md: '0 4px 20px rgba(0, 0, 0, 0.08)',
        lg: '0 8px 40px rgba(0, 0, 0, 0.12)'
    },
  };

  export const light = {
    name: "light-theme",
    colors: {
      bg: "#0f2537",
      bgGradient: `linear-gradient(135deg, #0d3040 0%, #2a2040 50%, #0d3040 100%)`,
      headline: "#ffffff",
      paragraph: "#94a3b8",
      cardBG: "#1e3448",
      cardText: "#e2e8f0",
      ff: "'Inter', sans-serif",
      ffHeading: "'DM Serif Display', serif",
      activeColor: "#22d3ee",
      activeColorDarkened: "#06b6d4",
      lightActiveHover: "#1a4a5e",
      contrastText: "#ffffff",
      borderColor: "#2d4a5e",
      opacityColor: "#243b53",
      subTextColor: "#94a3b8",
      inputBg: "#1e3448",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.4)",
      themeToggleTranslate: 'translateX(34px)',
      themeToggleContrast: 'white',
      themeActiveDisabled: '#2d4a5e',
      successColor: '#34d399',
      errorColor: '#f87171',
      warningColor: '#fbbf24'
    },
    radii: { sm: '8px', md: '12px', lg: '20px', pill: '50px' },
    shadows: {
        sm: '0 2px 8px rgba(0, 0, 0, 0.15)',
        md: '0 4px 20px rgba(0, 0, 0, 0.2)',
        lg: '0 8px 40px rgba(0, 0, 0, 0.3)'
    },
  };